export default "__VITE_ASSET__40137d1c__"